import { syncedGet, syncedSet } from '../data/serverStore';
export const PARAM_DEFS = {
  dissolved: [
    'Ag-Silver Dissolved','Al-Aluminum Dissolved','As-Arsenic Dissolved','Au-Gold Dissolved',
    'B-Boron Dissolved','Ba-Barium Dissolved','Be-Beryllium Dissolved','Ca-Calcium Dissolved',
    'Cd-Cadmium Leachable','Cd-Cadmium Dissolved','Co-Cobalt Dissolved','Cr-Chromium Dissolved',
    'Cr-Chromium Hexavalent','Cr-Chromium Hexavalent-1','Cu-Copper Dissolved','Fe-Iron Dissolved',
    'Ga-Gallium Dissolved','Hg-Mercury Dissolved','K-Potassium Dissolved','Li-Lithium Dissolved',
    'Mg-Magnesium Dissolved','Mn-Manganese Dissolved','Mo-Molybdenum Dissolved','Na-Sodium Dissolved',
    'Ni-Nickel Dissolved','Pb-Lead Dissolved','Pb-Lead Leachable','Pt-Platinum Dissolved',
    'Sb-Antimony Dissolved','Se-Selenium Dissolved','Si-Silicon Dissolved','SiO2-Silica Dissolved',
    'SiO2-Silica Non Reactive','SiO2-Silica Reactive','Sn-Tin Dissolved','Sr-Strontium Dissolved',
    'Tl-Thallium Dissolved','Ti-Titanium Dissolved','V-Vanadium Dissolved','W-Tungsten Dissolved',
    'Zn-Zinc Dissolved','Zr-Zirconium Dissolved'
  ],
  total: [
    'Ag-Silver Total','Al-Aluminum Total','Al-Aluminum Total, mg/kg','Al2O3',
    'As-Arsenic Total','As-Arsenic Total, mg/kg','As2O3','Au-Gold Total',
    'B-Boron Total','Ba-Barium Total','BaO','Be-Beryllium Total','Be-Beryllium Total, ug/kg',
    'Bi-Bismuth Total','Ca-Calcium Total','CaCO3','CaCO3 equivalence','CaO','CaO-Available',
    'Cd-Cadmium Total','Cd-Cadmium Total, mg/kg','Co-Cobalt Total','Cr-Chromium Total',
    'Cr-Chromium Trivalent','Cr2O3','Cu-Copper Total','Fe-Iron Total','Fe2O3','Fe3O4',
    'Ga-Gallium Total','Hg-Mercury Total','Hg-Mercury Total, mg/kg','In-Indium Total',
    'K-Potassium Total','K2O','Li-Lithium Total','Li2O','Metals Scan','Mg-Magnesium Total',
    'MgCO3','MgO','Mn-Manganese Total','Mn3O4','MnO2','Mo-Molybdenum Total',
    'Na-Sodium Total','Na2O','Ni-Nickel Total','P-Phosphorous Available','P-Phosphorous Total',
    'P2O5','Pb-Lead Total','Pb-Lead Total From Coating','Pb-Lead Total, mg/kg',
    'Pd-Palladium Total','Pt-Platinum Total','Sb-Antimony Total','Se-Selenium Total',
    'Si-Silicon Total','SiO2-Silica Non-Reactive','SiO2-Silica-Colloidal','SiO2-Silica-Reactive',
    'SiO2-Silica Total','Sn-Tin Total','SO2-Sulfur Dioxide','SO3','SO3-Sulfur Trioxide',
    'Sr-Strontium Total','SrO','Sulfur-Total','Ti-Titanium Total','TiO2','Tl-Thallium Total',
    'U-Uranium Total','V-Vanadium Total','V2O5','W-Tungsten Total','W-Tungsten, SPLP',
    'W-Tungsten, TCLP','Zn-Zinc Total','ZnO','Zr-Zirconium Total'
  ],
  nonmetals: [
    'Acid, Free','Acid, Total','Acid, Total as H2SO4','Acid, Total as HCl','Acid, Total as HNO3',
    'Alkalinity, Bicarbonate','Alkalinity, Carbonate','Alkalinity, Total','Ammonia-N',
    'Anionic Surfactant','Appearance/odor','Asbestos','Available Lime Index, CaO','Blistering',
    'BOD5','Bromide','Bromine','Bulk Density, lb/ft3','Carbon Dioxide-Dissolved',
    'Chemical Oxygen Demand','Chloride','Chlorine','Chlorine, mg/kg',
    "Chlorine, As Rec'd Basis, mg/kg",'Color','Conductivity','Corrosivity','Cracking',
    'Cyanide Total','Cyanide Total-1','Delamination','Density','Dissolved Inorganic Carbon',
    'Dissolved Organic Carbon','Dissolved Volatile Solids','Distillation Range oC',
    'Extractable Organic Halides','Fecal Coliform','Fineness','Flow, gpd','Fluoride',
    'Fluorine','Fluorine, mg/kg','Hardness as CaCO3','Hardness Non Carbonate',
    'Hi-Temp Coating','Hydrazine','Ignitability','Leachable Chloride','Leachable Halides',
    'Lime Equivalence, Ca(OH)2','Lime Equivalence, CaCO3','Lube Oil Analyses',
    'Melting Point Final, oC','Melting Point Initial, oC','Microbial Count, CFU/mL',
    'Microscopy','Moisture','Neutralization Potential','Nitrate-N','Nitrate/Nitrite-N',
    'Nitrite-N','Nitrogen-TKN','Nitrogen-Total Organic','O&G, Hydrocarbon Fraction-1',
    'Organic Content','Ortho Phosphate, as PO4','Particle Size','pH','pH (ASTM G51)',
    'pH(ASTM D4972)','Phosphate, as PO4','Reactivity: Cyanide','Reactivity: Sulfide',
    'Redox Potential','Resistivity','Rust','Salinity','Samples Pick up','Sediment, %',
    'Settleable Solids','Soil Evaluation','Specific Conductance','Specific Gravity',
    'Standard Plate Count, CFU/mL','Sulfate, as SO4','Sulfide, Total','Sulfur, Soluble',
    'Sulfur, Total','Surcharge',"T.O.C.-As Rec'd basis",'Total Acid #, as KOH',
    'Total Alkali, as NaOH','Total Base #, as KOH','Total Carbon','Total Coliform',
    'Total Dissolved Solids','Total Halides','Total Halogens','Total Halogens Aq',
    'Total Inorganic Carbon','Total Inorganic Solids','Total Insoluble Solids',
    'Total Oil & Grease','Total Oil & Grease-1','Total Oil & Grease-2','Total Oil & Grease-3',
    'Total Oil & Grease-4','Total Oil & Grease-5','Total Organic Carbon',
    'Total Organic Carbon Lloyd Kahn','Total Organic Carbon-Dup','Total Organic Carbon-USF',
    'Total Organic Content','Total Organic Halogens','Total Organic Halogens-Aq',
    'Total Organic Solids','Total Petroleum Hydro','Total Phosphoric Acid','Total Phosphorous',
    'Total Residual Oxidants','Total Residual Oxidants-c','Total Solids @ 104°C',
    'Total Suspended Solids','Total Suspended Solids >','Turbidity','Volatile Solids'
  ],
  fuel: [
    '#2 Fuel Oil','API Gravity @ 60°F','Appearance','Aromatics, % Vol.','Ash,%',
    "Ash,% - As Rec'd Basis",'Asphaeltenes, %','B Fusion-Reducing Atm.','Bacteria screening',
    'Bio-diesel vol %','Boiling Point, oF','Bromine, mg/kg','BTU/Gal','BTU/Lb',
    "BTU/Lb - As Rec'd Basis",'BTU/Lb- Moisture/Ash free','BTU/Lb, HHV','BTU/Lb, LHV',
    'C. Initial Deformation Temperature','c.Softening Temperature, °F','Calcium+Magnesium',
    'Carbon Residue,% (10% Bottoms)','Carbon,%','Carbon:Nitrogen Ratio,%','Carbonate Carbon,%',
    'Cetane Index','Cetane Index-2','Chlorine, mg/kg',"Chlorine,As Rec'd Basis  mg/kg",
    'Clear & Bright','Cloud Point, °F','Color','Compability','CU-Corrosion','CU-Corrosion Modified',
    'D. Softening Temperature','Demulsification','Dist Temp 50%, °F','Dist Temp 90%, °F',
    'Distillation, IBP, °F','Dynamic Viscosity, CGS@ 50°C','E .Hemispherical Temperature',
    'F.Fluid Temperature','Fixed Carbon, %','Flash Point, °F','Fluorine, mg/kg',
    'Free Fatty Acids','Fuel Oil #4','Fuel Oil #6','Fungi screening','Fusion-Oxidizing, °F',
    'Gasoline','Grindability-HGI','Hydrogen,%','Ignitability','Initial Boiling Point, oF',
    'Initial pH','Initial Softening Temperature','Iodine','Iron','Kerosene','Lead',
    'Loss on Ignition, %','Loss, Volume%','Lubricity/Gms','Metals, ppm','Moisture-Air Dried, %',
    'Moisture, %','Mold','Motor Oil','Nitrogen,%','Non Volatile Matter, %','Oil % Vol',
    'Oxygen,%','Paraffin, %','Particle Size  4','Particle Size  6','Particle Size  14',
    'Particle Size  21','Particle Size  38','Particle Size  74','Particle Size 4',
    'Particle Size Distribution','Particulates, mg/1000 ml','Pour Point, °F',
    'Recovered-10%, °F','Recovered-50%, °F','Recovered-90%, °F','Residue, Volume%',
    'S.H.F., %','Sediment, %','Sediment,% (by volume)','Sieve  Sizes:','Size Distribution',
    'Size, greater than #200','Size, less than #100','Size, less than #200','SO3',
    'Sodium, Potassium, plus Lithium','Sodium, ppm','Specific Gravity@ 60°F',
    'Specific Gravity@ 70°F','Specific Gravity@ 90°F','Sulfur in Petroleum, %','Sulfur, %',
    "Sulfur, %-As Rec'd Basis",'Sulfur, ppm','T250 oF','Unburned Carbon,%','Unidentified',
    'Vanadium, ppm','Visc.Dynamic, CP@ 40°C','Visc.KinematicCST@ 100°F',
    'Visc.KinematicCST@ 10°C','Visc.KinematicCST@ 122°F','Visc.KinematicCST@ 12°C',
    'Visc.KinematicCST@ 130°F','Visc.KinematicCST@ 140°F','Visc.KinematicCST@ 145°F',
    'Visc.KinematicCST@ 150°F','Visc.KinematicCST@ 170°F','Visc.KinematicCST@ 20°C',
    'Visc.KinematicCST@ 40°C','Visc.KinematicCST@ 70°F','Visc.KinematicCST@ 90°F',
    'Viscosity, SSF @ 100°F','Viscosity, SSF @ 122°F','Viscosity, SSF @ 140°F',
    'Viscosity, SSF @ 160°F','Viscosity, SSF @ 170°F','Viscosity, SSF @ 210°F',
    'Viscosity, SSF @ 70°F','Viscosity, SSU @ 100°F','Volatile Matter, %',
    'Water & Sed., % (by volume)','Water, % (by volume)','Water, Karl Fischer Coul',
    'Water, Karl Fischer, Vol'
  ],
  rare: [
    'Ce-Cerium','Dy-Dysprosium','Er-Erbium','Eu-Europium','Gd-Gadolinium','Ho-Holmium',
    'La-Lanthanum','Lu-Lutetium','Nd-Neodymium','Pr-Praseodymium','Sc-Scandium',
    'Sm-Samarium','Tb-Terbium','Tm-Thulium','Y-Yttrium','Yb-Ytterbium'
  ],
  gc: [
    'Aldrin','Aroclor-1016','Aroclor-1221','Aroclor-1232','Aroclor-1242','Aroclor-1248',
    'Aroclor-1254','Aroclor-1260','Alpha-BHC','Beta-BHC','Delta-BHC','Gamma-BHC (Lindane)',
    "4,4'-DDD","4,4'-DDE","4,4'-DDT",'Dieldrin','Endosulfan I','Endosulfan II',
    'Endosulfan Sulfate','Endrin','Endrin Aldehyde','Endrin Ketone','Heptachlor',
    'Heptachlor Epoxide','Methoxychlor','Toxaphene','Benzene','Toluene','Ethylbenzene',
    'Xylene (total)','BTEX','Chlorobenzene','1,2-Dichloroethane','1,1-Dichloroethylene',
    'Methylene Chloride','Tetrachloroethylene','1,1,1-Trichloroethane','Trichloroethylene',
    'Vinyl Chloride','TPH-Gasoline Range','TPH-Diesel Range','TPH-Oil Range',
    'Naphthalene','Acenaphthylene','Acenaphthene','Fluorene','Phenanthrene','Anthracene',
    'Fluoranthene','Pyrene','Benzo(a)anthracene','Chrysene','Benzo(b)fluoranthene',
    'Benzo(k)fluoranthene','Benzo(a)pyrene','Dibenzo(a,h)anthracene',
    'Benzo(g,h,i)perylene','Indeno(1,2,3-cd)pyrene','Total PAHs'
  ]
};

export const AUTO_PACKAGES = {
  npdes: {
    label: 'NPDES',
    params: ['pH','Total Suspended Solids','Total Dissolved Solids','BOD5',
      'Chemical Oxygen Demand','Nitrogen-TKN','Ammonia-N','Total Phosphorous',
      'Fecal Coliform','Al-Aluminum Total','Fe-Iron Total','Nitrate-N',
      'Total Organic Carbon','Conductivity','Turbidity','Sulfate, as SO4','Chloride']
  },
  aquatic: {
    label: 'Aquatic Toxicity',
    params: ['pH','Hardness as CaCO3','Conductivity','Total Dissolved Solids',
      'Alkalinity, Total','Al-Aluminum Total','Cu-Copper Total','Zn-Zinc Total',
      'Ammonia-N','Total Organic Carbon','Turbidity','Temperature']
  },
  wells: {
    label: 'Wells',
    params: ['pH','Conductivity','Turbidity','Total Dissolved Solids','Hardness as CaCO3',
      'Alkalinity, Total','Sulfate, as SO4','Chloride','Fe-Iron Total','Mn-Manganese Total',
      'Nitrate-N','Sodium, ppm','Ca-Calcium Total','Mg-Magnesium Total']
  },
  tclp: {
    label: 'TCLP',
    params: ['As-Arsenic Total','Ba-Barium Total','Cd-Cadmium Total','Cr-Chromium Total',
      'Pb-Lead Total','Hg-Mercury Total','Se-Selenium Total','Ag-Silver Total',
      'Benzene','Toluene','Trichloroethylene','1,1-Dichloroethylene',
      'Tetrachloroethylene','Methylene Chloride','Vinyl Chloride']
  },
  specific: {
    label: 'Specific Analysis',
    params: ['Al-Aluminum Total','Cu-Copper Total','pH','Total Dissolved Solids','Turbidity']
  },
  fuel: {
    label: 'Fuel',
    params: ['API Gravity @ 60°F','Flash Point, °F','Viscosity, SSF @ 100°F','Sulfur, %',
      'Water & Sed., % (by volume)','Sediment, %','Cloud Point, °F','Pour Point, °F',
      'Cetane Index','BTU/Gal','Ash,%','Carbon Residue,% (10% Bottoms)']
  },
  qaoc: {
    label: 'QA/QC',
    params: ['pH','Total Dissolved Solids','Conductivity','Total Suspended Solids',
      'Turbidity','Total Organic Carbon']
  },
  coal: {
    label: 'Coal',
    params: ["Ash,%","Moisture, %","Sulfur, %","BTU/Lb","Fixed Carbon, %",
      "Volatile Matter, %","Carbon,%","Hydrogen,%","Nitrogen,%",
      "Ash,% - As Rec'd Basis","BTU/Lb, HHV","BTU/Lb, LHV"]
  }
};

export const TEST_CATEGORIES = [
  'Specific Analysis','NPDES','Aquatic Toxicity','Wells','TCLP','Fuel','QA/QC','Coal'
];

export const SAMPLE_FORMS = ['Aqueous','Solid','Oil','Fuel','Air','Tissue','Sludge','Soil'];

export const getDefaultUnit = (param) => {
  if (!param) return 'mg/L';
  const p = param.toLowerCase();
  if (p.includes('mg/kg')) return 'mg/kg';
  if (p.includes('ug/kg')) return 'ug/kg';
  if (p.startsWith('ph') || p === 'ph') return 'SU';
  if (p.includes('temp') || p.includes('°c')) return '°C';
  if (p.includes('%')) return '%';
  if (p.includes('cfu')) return 'CFU/mL';
  if (p.includes('gpd') || p.includes('flow')) return 'gpd';
  if (p.includes('btu')) return 'BTU/lb';
  if (p.includes('turbidity')) return 'NTU';
  if (p.includes('conductivity')) return 'uS/cm';
  if (p.includes('resistivity')) return 'ohm-cm';
  if (p.includes('gravity')) return 'API';
  if (p.includes('viscosity') || p.includes('visc')) return 'cSt';
  if (p.includes('ppm')) return 'ppm';
  return 'mg/L';
};

// ── Parameter metadata: ASTM methods and specifications ──────────────────────
// Format: { method, spec }  spec is optional
export const PARAM_META = {
  // Fuel / Petroleum
  'Flash Point, °F':                    { method:'D-93',        spec:'125 Min.' },
  'Cloud Point, °F':                    { method:'D-2500',      spec:'24 Max.' },
  'CU-Corrosion':                       { method:'D-130',       spec:'0-3' },
  'Ash,%':                              { method:'D-482',       spec:'' },
  'Carbon Residue,% (10% Bottoms)':     { method:'D-524',       spec:'0.35 Max.' },
  'API Gravity @ 60°F':                 { method:'D-287',       spec:'' },
  'Cetane Index':                       { method:'D-976',       spec:'40 Min.' },
  'Cetane Index-2':                     { method:'D-4737',      spec:'40 Min.' },
  'Viscosity,KinematicCST@ 40°C':       { method:'D-445',       spec:'1.9-4.1 CST' },
  'Viscosity,KinematicCST@ 100°C':      { method:'D-445',       spec:'' },
  'Water & Sed. % (by volume)':         { method:'D-1796-83',   spec:'0.05 Max.' },
  'Distillation, IBP, °F':              { method:'D-86',        spec:'' },
  'Dist Temp 10%':                      { method:'D-86',        spec:'' },
  'Dist Temp 50%':                      { method:'D-86',        spec:'' },
  'Dist Temp 90%':                      { method:'D-86',        spec:'540-640(F)' },
  'Distillation Recovery':              { method:'D-86',        spec:'' },
  'Sulfur, ppm':                        { method:'D-5453',      spec:'' },
  'Sulfur, %':                          { method:'D-4294',      spec:'' },
  'Sulfur, Total':                      { method:'D-4294',      spec:'' },
  'Pour Point, °F':                     { method:'D-97',        spec:'' },
  'BTU/Lb':                             { method:'D-240',       spec:'' },
  'BTU/Gal':                            { method:'D-240',       spec:'' },
  'Water, % (Karl Fischer)':            { method:'D-6304',      spec:'' },
  'Water, %':                           { method:'D-95',        spec:'' },
  'Sediment, %':                        { method:'D-473',       spec:'' },
  'Aromatics, % Vol.':                  { method:'D-1319',      spec:'' },
  'Olefins, % Vol.':                    { method:'D-1319',      spec:'' },
  'Saturates, % Vol.':                  { method:'D-1319',      spec:'' },
  'Acid Number, mgKOH/g':               { method:'D-664',       spec:'' },
  'Total Acid #, as KOH':               { method:'D-664',       spec:'' },
  'Total Base #, as KOH':               { method:'D-2896',      spec:'' },
  'Color':                              { method:'D-1500',      spec:'' },
  'Density':                            { method:'D-4052',      spec:'' },
  'Specific Gravity':                   { method:'D-4052',      spec:'' },
  'Lubricity, HFRR':                    { method:'D-6079',      spec:'520 Max.' },
  'Oxidation Stability':                { method:'D-2274',      spec:'2.5 Max.' },
  'Heat of Combustion':                 { method:'D-240',       spec:'' },
  'Volatile Matter, %':                 { method:'D-3175',      spec:'' },
  'Fixed Carbon, %':                    { method:'D-3172',      spec:'' },
  'Moisture, %':                        { method:'D-3173',      spec:'' },
  "Moisture-Air Dried, %":              { method:'D-3173',      spec:'' },
  "Ash,% - As Rec'd Basis":            { method:'D-3174',      spec:'' },

  // TCLP / EPA Methods
  'Ag-Silver':                          { method:'EPA 6010',    spec:'5.0 mg/L' },
  'Ag-Silver Dissolved':                { method:'EPA 6010',    spec:'5.0 mg/L' },
  'As-Arsenic':                         { method:'EPA 6010',    spec:'5.0 mg/L' },
  'As-Arsenic Dissolved':               { method:'EPA 6010',    spec:'5.0 mg/L' },
  'Ba-Barium':                          { method:'EPA 6010',    spec:'100 mg/L' },
  'Ba-Barium Dissolved':                { method:'EPA 6010',    spec:'100 mg/L' },
  'Cd-Cadmium':                         { method:'EPA 6010',    spec:'1.0 mg/L' },
  'Cd-Cadmium Dissolved':               { method:'EPA 6010',    spec:'1.0 mg/L' },
  'Cd-Cadmium Leachable':               { method:'EPA 6010',    spec:'1.0 mg/L' },
  'Cr-Chromium':                        { method:'EPA 6010',    spec:'5.0 mg/L' },
  'Cr-Chromium Dissolved':              { method:'EPA 6010',    spec:'5.0 mg/L' },
  'Hg-Mercury':                         { method:'EPA 7470',    spec:'0.2 mg/L' },
  'Hg-Mercury Dissolved':               { method:'EPA 7470',    spec:'0.2 mg/L' },
  'Pb-Lead':                            { method:'EPA 6010',    spec:'5.0 mg/L' },
  'Pb-Lead Dissolved':                  { method:'EPA 6010',    spec:'5.0 mg/L' },
  'Pb-Lead Leachable':                  { method:'EPA 6010',    spec:'5.0 mg/L' },
  'Se-Selenium':                        { method:'EPA 6010',    spec:'1.0 mg/L' },
  'Se-Selenium Dissolved':              { method:'EPA 6010',    spec:'1.0 mg/L' },

  // Water / Environmental
  'pH':                                 { method:'EPA 150.1',   spec:'6.5-8.5 SU' },
  'Conductivity':                       { method:'EPA 120.1',   spec:'' },
  'Specific Conductance':               { method:'EPA 120.1',   spec:'' },
  'Total Dissolved Solids':             { method:'EPA 160.1',   spec:'500 Max.' },
  'Total Suspended Solids':             { method:'EPA 160.2',   spec:'' },
  'BOD5':                               { method:'EPA 405.1',   spec:'' },
  'Chemical Oxygen Demand':             { method:'EPA 410.4',   spec:'' },
  'Total Organic Carbon':               { method:'EPA 415.1',   spec:'' },
  'Ammonia-N':                          { method:'EPA 350.1',   spec:'' },
  'Nitrate-N':                          { method:'EPA 353.2',   spec:'10 mg/L' },
  'Nitrate/Nitrite-N':                  { method:'EPA 353.2',   spec:'' },
  'Nitrite-N':                          { method:'EPA 354.1',   spec:'' },
  'Nitrogen-TKN':                       { method:'EPA 351.2',   spec:'' },
  'Phosphate, as PO4':                  { method:'EPA 365.1',   spec:'' },
  'Ortho Phosphate, as PO4':            { method:'EPA 365.1',   spec:'' },
  'Chloride':                           { method:'EPA 325.2',   spec:'' },
  'Sulfate, as SO4':                    { method:'EPA 375.4',   spec:'250 Max.' },
  'Fluoride':                           { method:'EPA 340.2',   spec:'4.0 Max.' },
  'Total Coliform':                     { method:'EPA 9222',    spec:'0 per 100mL' },
  'Fecal Coliform':                     { method:'EPA 9222D',   spec:'0 per 100mL' },
  'Total Oil & Grease':                 { method:'EPA 1664',    spec:'' },
  'Turbidity':                          { method:'EPA 180.1',   spec:'1 NTU' },
  'Hardness as CaCO3':                  { method:'EPA 130.2',   spec:'' },
  'Alkalinity, Total':                  { method:'EPA 310.1',   spec:'' },
  'Dissolved Oxygen':                   { method:'EPA 360.1',   spec:'5.0 Min.' },
  'Cyanide Total':                      { method:'EPA 335.4',   spec:'' },
};

export const getParamMeta = (param) => {
  if (!param) return { method:'', spec:'' };
  // Check localStorage overrides first (set via ParamManager)
  try {
    const saved = JSON.parse((syncedGet('sl_param_meta', null) !== null ? JSON.stringify(syncedGet('sl_param_meta', null)) : null) || '{}');
    if (saved[param]) return { method: saved[param].method||'', spec: saved[param].spec||'' };
  } catch {}
  // Exact match in built-in table
  if (PARAM_META[param]) return PARAM_META[param];
  // Partial match for variants
  const p = param.toLowerCase();
  for (const [key, val] of Object.entries(PARAM_META)) {
    if (p.includes(key.toLowerCase()) || key.toLowerCase().includes(p.split(',')[0])) {
      return val;
    }
  }
  return { method:'', spec:'' };
};
